import React from 'react';
import { Paper, Typography, Box } from '@mui/material';
import { LightbulbOutlined as TipIcon } from '@mui/icons-material';

interface TipCardProps {
  title: string;
  description: string;
}

const TipCard: React.FC<TipCardProps> = ({ title, description }) => {
  return (
    <Paper
      variant="outlined"
      sx={{
        p: 2,
        bgcolor: 'warning.50',
        borderColor: 'warning.200',
        height: '100%',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5 }}>
        <TipIcon sx={{ color: 'warning.main', fontSize: 24, mt: 0.25 }} />
        <Box>
          <Typography variant="subtitle2" fontWeight={600} gutterBottom>
            {title}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {description}
          </Typography>
        </Box>
      </Box>
    </Paper>
  );
};

export default TipCard;
